import type { Router } from 'vue-router'

import type { HeaderLinkInternal } from '@scalar-org/entities/project'

/** * Resolve the link (href) for an internal header item */
export function resolveHeaderLink(item: HeaderLinkInternal, router: Router) {
  return router.resolve({ name: item.uid }).href
}
